// Load jQuery from NPM
import $ from 'jquery';
// import Swiper from 'swiper/swiper-bundle';
import filterSelect from './partials/filter';
import { gsap } from "gsap";
import './partials/datepicker';


import inputItems from './partials/input';
import navItem from './partials/nav';
//import fancyBoxModel from './partials/fancyboxmodel';
import fancyBox from './partials/fancyBox';
fancyBox();
// import SwiperSlider from './partials/swiper';
import headerModel from './partials/header-model';
import './partials/animation';
import './partials/swiper';

import isotope from 'isotope-layout';

import './partials/accordion';
import './partials/multi-step';
import './partials/backend';
import './partials/custom-select';
// import './partials/dropzone';

window.jQuery = $;
window.$ = $;


inputItems('input:not([type=checkbox]), textarea');
filterSelect('.custom-select', '.dropdown-checkboxes');
navItem('#mainmenu .menu-main > ul > li > a:not(.no-inner-menu)');
//fancyBoxModel('a[data-fancybox]');

// SwiperSlider ('.credentials-slider', '.counselor-slider');
headerModel('.model-trigger');

//isoGallery('.gallery-grid');


// GSAP: turn off console warnings
gsap.config({
    nullTargetWarn: false
});



$(document).ready(function() {



    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $("html").addClass("mac");
    } else {
        $("html").addClass("pc");
    }

    // text animation
    // setTimeout(() => {
    //     $('.a-rise')
    //       .removeClass('a-rise')
    //       .addClass('a-fall');
    // }, 3000)


    setInterval(function() {
        $(".birthday-welcome-box .welcome-to-peaks").fadeToggle(300);
    }, 10000);


    const appHeight = () => {

        // Get header height and set to css var
        var header = document.getElementById("header"),
            headerHeight = header.offsetHeight;

        const doc = document.documentElement
        doc.style.setProperty('--app-height', `${window.innerHeight}px`)
        doc.style.setProperty('--header-height', `${headerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight();

    if ($('#track').length) {
        // var track = document.getElementById('track');
        // var controlBtn = document.getElementById('play-pause');

        // function playPause() {
        //     if (track.paused) {
        //         track.play();
        //         //controlBtn.textContent = "Pause";
        //         controlBtn.className = "pause";
        //     } else { 
        //         track.pause();
        //         //controlBtn.textContent = "Play";
        //         controlBtn.className = "play";
        //     }
        // }
        // controlBtn.addEventListener("click", playPause);
        // track.addEventListener("ended", function() {
        //     controlBtn.className = "play";
        // });



        // var track = document.getElementById('track');
        // var controlBtn = document.getElementById('play-pause');

        // function playPause() {
        //     if (track.paused) {
        //         track.play();
        //         //controlBtn.textContent = "Pause";
        //         controlBtn.className = "pause";
        //     } else { 
        //         track.pause();
        //         //controlBtn.textContent = "Play";
        //         controlBtn.className = "play";
        //     }
        // }
        // controlBtn.addEventListener("click", playPause);
        // track.addEventListener("ended", function() {
        //     controlBtn.className = "play";
        // });

    }



    // Header sticky
    var intialtop = $(document).scrollTop();
    var headerheight = $("#header").outerHeight();
    $(window).scroll(function() {
        var afterscrolltop = $(document).scrollTop();
        if (afterscrolltop > headerheight) {
            if (!$("#header").hasClass('navhide')) {
                $("#header").addClass("not-animate");
            }
            $("#header").addClass("navhide");
            setTimeout(function() {
                $("#header").removeClass("not-animate");
            }, 10)


            if (afterscrolltop > intialtop) {
                $("#header").removeClass("navshow");
                $("body").removeClass("header-show");
            } else {
                $("#header").addClass("navshow");
                $("body").addClass("header-show");
            }

        } else {
            $("#header").removeClass("navhide");
        }

        if (afterscrolltop == 0) {
            $("#header").removeClass("navshow");
            $("body").removeClass("header-show");
        }
        intialtop = $(document).scrollTop();
    });


    if ($('.video-box video').length) {
        var screenWidth = $(window).width();
        if (screenWidth <= 767) {
            // $('.video-box video').attr('autoplay', 'autoplay');
            $('.video-box video').trigger('pause');
        }
    }


    if ($('.audio-box').length) {
        // var audioTrackAll = $('.audio-track'),
        //     audiocontrolBtnAll = $('.audio-box1').find('.play-pause');

        $('.audio-box').each(function() {
            var audioTrack = $(this).find('.audio-track')[0],
                audiocontrolBtn = $(this).find('.play-pause');
            audiocontrolBtn.on('click', function() {
                if (audioTrack.paused) {
                    // audioTrackAll.pause();
                    // audioTrackAll.removeClass('pause').addClass('play');
                    $('.audio-box').each(function() {
                        var audioTrackAll = $(this).find('.audio-track')[0],
                            audiocontrolBtnAll = $(this).find('.play-pause');
                        audioTrackAll.pause(); // Stop playing
                        audioTrackAll.currentTime = 0; // Reset time
                        audiocontrolBtnAll.removeClass('pause').addClass('play');
                    });

                    audioTrack.play();
                    audiocontrolBtn.removeClass('play').addClass('pause');
                    // audiocontrolBtn.className = "pause";
                    let trackUrl = audioTrack.currentSrc.split("/");
                    window.dataLayer.push({
                        'event': 'sound',
                        'title': trackUrl[trackUrl.length - 1],
                    });

                } else {
                    audioTrack.pause();
                    // audiocontrolBtn.className = "play";
                    audiocontrolBtn.removeClass('pause').addClass('play');
                }

                return false
            })
        })
    }

    /*Sticky
    ---------------------------------------------------------------------*/
    if ($(".sub-navigation").length) {
        $(window).on('resize', function() {
            var subNavTopWidth = $(".sub-navigation-list > ul").outerWidth();
            if (subNavTopWidth >= ($('.sub-navigation-main').width())) {
                $('.sub-navigation-main').addClass('active');
            } else {
                $('.sub-navigation-main').removeClass('active');
            }
        }).resize();

        // Sub navigation sticky update
        var subNavTop = $(".sub-navigation").next("*")[0].offsetTop - $(".sub-navigation").outerHeight();
        var subNavHeight = subNavTop - ($(".sub-navigation").outerHeight());
        var topVal = subNavTop;
        
        $(window).on('scroll', function() {
            if ($('body').hasClass('header-show') && $('.sub-navigation').hasClass('sticky')) {
                topVal = subNavHeight
            } else {
                topVal = subNavTop;
            }

            if ($(this).scrollTop() > topVal) {
                $(".sub-navigation").addClass("sticky");
            } else {
                $(".sub-navigation").removeClass("sticky");
            }
        });
    }


    // Search input close button
    $('form').on('focus blur keyup', '#header_search', function() {
        var searchValue = $(this).val();
        if (searchValue == "") {
            $(this).parents('.form-group').removeClass('filled');
            $(this).parents('.form-group').find('.input-clear').fadeOut();
            $(this).parents('.form-group').find('button').fadeIn();
        } else {
            $(this).parents('.form-group').addClass('filled');
            $(this).parents('.form-group').find('.input-clear').fadeIn();
            $(this).parents('.form-group').find('button').fadeOut();
        }
    })

    $('form').on('click', '.input-clear', function(e) {
        e.preventDefault();
        $(this).parents('.form-group').find('#header_search').val('');
        $('#header_search').focus()
        return false;
    });


    // Set full width to banner section
    if ($('.services-main').length) {
        const serviceSecWidth = () => {
            const doc = document.documentElement;
            const docWidth = doc.clientWidth;
            const serviceWidth = document.querySelector('.services-main').offsetWidth;
            // const serviceWidthCalc = serviceWidth - (docWidth / 2);
            const serviceWidthCalc = ((docWidth - serviceWidth) / 2).toFixed();
            doc.style.setProperty('--serviceWidth', serviceWidthCalc + 'px');
        }
        window.addEventListener('resize', serviceSecWidth)
        serviceSecWidth()
    }


    // Drawer right
    // $(document).on('click', '.drawer_trigger', function(){
    //     var drawID = $(this).attr('data-drawer');
    //     // console.log(drawID);
    //     $('#'+drawID).show(0, function(){
    //         $('#'+drawID+' .drawer-overlay').fadeIn(350);
    //         $('body').addClass('overflowhidden');
    //         gsap.to($('#'+drawID+' .drawer-block'), {transform: 'translateX(0)', duration:0.350});
    //     })
    //     $('#'+drawID).focus();
    //     return false;
    // })

    // $(document).on('click', '.drawer-close, .drawer-overlay', function(){
    //     $('.drawer-main .drawer-overlay').fadeOut(350);
    //     $('body').removeClass('overflowhidden');
    //     gsap.to($('.drawer-main .drawer-block'), {transform: 'translateX(100%)', duration:0.350, onComplete: function(){
    //         $('.drawer-main').hide();
    //     }});
    //     return false;
    // })


    // Check if checkbox is checked or not
    if ($('.submit-row .privacy-checkbox').length) {
        $('.submit-row .privacy-checkbox').each(function() {
            var $this = $(this);

            function checkboxChecked() {
                if ($this.is(':checked')) {
                    $this.parents('.submit-row').addClass('active');
                } else {
                    $this.parents('.submit-row').removeClass('active');
                }
            }
            checkboxChecked();
            $($this).change(function() {
                checkboxChecked()
            })
        })
    }

    // Sub nav scroll animation
    if ($('.sub-navigation-list').length) {

        var lastId,
            topMenu = $(".sub-navigation-list"),
            topMenuHeight = topMenu.outerHeight() + 15,
            // All list items
            menuItems = topMenu.find("a"),
            // Anchors corresponding to menu items
            scrollItems = menuItems.map(function() {
                var item = $($(this).attr("href"));
                if (item.length) { return item; }
            });

        // Bind click handler to menu items
        // so we can get a fancy scroll animation
        menuItems.click(function(e) {
            var href = $(this).attr("href"),
                offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
            $('html, body').stop().animate({
                scrollTop: offsetTop
            }, 300);
            e.preventDefault();
        });

        // Bind to scroll
        $(window).scroll(function() {
            // Get container scroll position
            var fromTop = $(this).scrollTop() + topMenuHeight;
            // Get id of current scroll item
            var cur = scrollItems.map(function() {
                if ($(this).offset().top < fromTop)
                    return this;
            });
            // Get the id of the current element
            cur = cur[cur.length - 1];
            var id = cur && cur.length ? cur[0].id : "";
            if (lastId !== id) {
                lastId = id;
                // Set/remove active class
                menuItems.parent().removeClass("active").end().filter("[href='#" + id + "']").parent().addClass("active");
            }
        });
    }



    // Search open
    // $(document).on('click', '#serch-btn', function(e) {
    //     e.preventDefault();
    //     var $body = $('body');
    //     if($('.search-main').hasClass('open')){

    //     } else {
    //         $body.addClass('overflowhidden');
    //         $('.search-main').addClass('open');
    //         gsap.fromTo('.search-main', {transform: 'translateY(-100%)'}, {transform: 'translateY(0)', duration:0.350, ease:'power1.out'});
    //     }

    //     return false;
    // })

    // var newsSwiper = new Swiper('.credentials-slider', {
    // grabCursor: true,
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    // pagination: {
    //     el: '.swiper-pagination',
    //     type: "fraction",
    // },
    // effect: "creative",
    // creativeEffect: {
    //     prev: {
    //     shadow: true,
    //     scale: 1.2,
    //     origin: `right center`,
    //     opacity: 0,
    //     translate: ["-27%", 0, 100],
    //     },
    //     next: {
    //     translate: ["27%", 0, -400],
    //     origin: `right center`,
    //     //scale: 0.75,
    //     opacity: 0.2,
    //     },
    // },
    // });
    // var swiper = new Swiper('.counselor-slider', {
    // slidesPerView: 1,
    // spaceBetween: 24,
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    // breakpoints: {
    //     640: {
    //     slidesPerView: 2,
    //     spaceBetween: 24,
    //     },
    //     768: {
    //     slidesPerView: 2,
    //     spaceBetween: 24,
    //     },
    //     1024: {
    //     slidesPerView: 2,
    //     spaceBetween: 40,
    //     },
    //     1200: {
    //     slidesPerView: 3,
    //     spaceBetween: 40,
    //     },
    // },
    // });



    // Development js
    // ==============================================================================
    const Loader = $(".loader-cart");

    if ($("#ajax-post-list").length) {
        var paged = 1;
        var loadmore = false;
        var currentRequest = null;
        $(window).scroll(function() {
            if (loadmore == true) {
                if ($("#ajax-post-list").height() < $(window).scrollTop() - 100) {
                    loadmore = false;
                    loadPosts();
                }
            }
        });

        // Referenzen Filter
        $("#ajax-post-list form").change((e) => {
            e.preventDefault();
            $(".filter-reset .filter-btn").show();
            paged = 1;
            loadPosts();
        });

        

        // Ratgeber Filter
        $("#ajax-post-list .filter-categories a.tag, #ajax-post-list .filter-location a.tag").click((e) => {
            $(".filter-reset .filter-btn").show();
            paged = 1;
            setTimeout(() => {
                loadPosts();
            }, 1000)
        })

        $(".filter-reset a.filter-btn").click((e) => {
            $(e.target).hide();
            $(".filter-number").hide();
            $("#ajax-post-list form").trigger("reset");
            $('#ajax-post-list form input[type="checkbox"]').removeAttr("checked");
            $("#ajax-post-list .filter-categories a.tag").removeClass("active");

            $('.filter-categories, .filter-location').removeClass('active');
            $('.filter-categories > .tag, .filter-location > .tag').removeClass('active');
            paged = 1;
            loadPosts();
            return false;
        })

        function loadPosts(loader = true) {
            if (loader == true) {
                Loader.show();
            }

            var cat_num = $('.products input[name="category[]"]:checked').filter(":checked").length;
            if (cat_num > 0) {
                $(".cat_num .filter-number").show();

            }
            var sec_num = $('.products input[name="sector[]"]:checked').filter(":checked").length;
            if (sec_num > 0) {
                $(".sec_num .filter-number").show();

            }
            Loader.show();
            let posttype = $("#ajax-post-list").data("post");
            var category = [];
            var sector = [];
            $('.products input[name="category[]"]:checked').each(function() {
                category.push(this.value);

            });
            $('.bruchens input[name="sector[]"]:checked').each(function() {
                sector.push(this.value);
            });

            let formdata
            if (posttype == 'referenzen' ) {
                //  $('.filter-result-row').append('<div id="loaderajax"><div class="loader-ajax"><div class="loader-wrap"><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div></div><div class="loader-text">Please wait</div></div></div>');
                currentRequest = $.ajax({
                    url: WP.AJAX_URL,
                    method: 'POST',
                    data: {
                        paged: paged,
                        category: category,
                        sector: sector,
                        action: 'peakmedia_' + posttype,
                    },
                    beforeSend: function() {
                        if (currentRequest != null) {
                            currentRequest.abort();
                        }
                    },
                    success: function(response) {



                        let result = JSON.parse(response);
                        // alert("hello4");
                        if (paged == 1) {
                            $(".filter-result-row .cols3").html(result.html);
                        } else {
                            $(".filter-result-row .cols3").append(result.html);
                        }
                        loadmore = result.hasmore;
                        paged++;
                        Loader.hide();
                        if($('.filter-result-row .cols .col').length == 0){
                            $('.filter-result-row .cols').append('<p class="error-msg">Keine Ergebnisse für diese Auswahl gefunden.</p>')
                        }else{
                            if($('.error-msg').length){
                                $('.error-msg').remove()
                            }
                        }
                    },
                    complete: function() {
                        setTimeout(() => {

                            $('#loaderajax').fadeOut(450, function() {
                                $(this).remove();
                            });
                        }, "1000")
                    },
                    error: function(err) {
                        console.warn(err);
                    }
                });
            } else {
                formdata = { category: $("#ajax-post-list .filter-categories a.tag.active").map((i, e) => $(e).data("id")).get() };
                currentRequest = $.ajax({
                    url: WP.AJAX_URL,
                    method: 'POST',
                    data: {
                        paged,
                        formdata,
                        action: 'peakmedia_' + posttype,
                    },
                    beforeSend: function() {
                        if (currentRequest != null) {
                            currentRequest.abort();
                        }
                    },
                    success: function(response) {
                        let result = JSON.parse(response);
                        // alert("hello4");
                        if (paged == 1) {
                            $(".filter-result-row .cols3").html(result.html);
                        } else {
                            $(".filter-result-row .cols3").append(result.html);
                        }
                        loadmore = result.hasmore;
                        if(posttype!='team'){
                            paged++;
                        }
                        Loader.hide();
                        if($('.filter-result-row .cols .col').length == 0){
                            $('.filter-result-row .cols').append('<p class="error-msg">Keine Ergebnisse für diese Auswahl gefunden.</p>')
                        }else{
                            if($('.error-msg').length){
                                $('.error-msg').remove()
                            }
                        }
                    },
                    error: function(err) {
                        console.warn(err);
                    }
                });
            }

            // let posttype = $("#ajax-post-list").data("post");
            // let formdata = null
            // if(posttype == 'referenzen') {
            //     formdata = $("#ajax-post-list form").serialize();
            // } else {
            //     formdata = {
            //         category: $("#ajax-post-list .filter-categories a.tag.active").map((i,e) => $(e).data("id")).get(),
            //         location: $("#ajax-post-list .filter-location a.tag.active").map((i,e) => $(e).data("id")).get()
            //     };
            // }
            // currentRequest = $.ajax({
            //     url: WP.AJAX_URL,
            //     method: 'POST',
            //     data:{
            //         paged,
            //         formdata,
            //         action:'peakmedia_'+posttype,
            //     },
            //     beforeSend: function() {
            //         if(currentRequest != null) {
            //             currentRequest.abort();
            //         }
            //     },
            //     success: function(response) {                
            //         let result = JSON.parse(response);
            //         if(paged == 1) {
            //             $(".filter-result-row .cols3").html(result.html);
            //         } else  {
            //             $(".filter-result-row .cols3").append(result.html);
            //         }
            //         loadmore = result.hasmore;
            //         paged++;
            //         Loader.hide();
            //     },
            //     error:function(err) {
            //         console.warn(err);                        
            //     }
            // });
        }

        setTimeout(function() {
            if (window.cat2 == 0 && window.cat1 == 0)
                loadPosts(false);
        }, 1000);

    }


    // Open & Fetch Drawer Team Details
    $(document).on("click", ".drawer_trigger", (e) => {
        Loader.show();
        var drawID = $(e.target).data("drawer") ? $(e.target).data("drawer") : $(e.target).closest("a.drawer_trigger").data("drawer");
        let team_id = $(e.target).data("id") ? $(e.target).data("id") : $(e.target).closest("a.drawer_trigger").data("id");
        let slug = $(e.target).data("slug") ? $(e.target).data("slug") : $(e.target).closest("a.drawer_trigger").data("slug");
        if (slug) {
            window.history.replaceState('', '', `/team/${slug}`);
        }
        $.ajax({
            url: WP.AJAX_URL,
            method: 'POST',
            data: {
                team_id,
                action: 'get_peakmedia_team_details',
            },
            success: function(response) {
                let result = JSON.parse(response);
                if (result.success == 1) {
                    $("#team01_drawer .drawer-box").html(result.html);
                }
                Loader.hide();
                $('#' + drawID).show(0, function() {
                    $('#' + drawID + ' .drawer-overlay').fadeIn(350);
                    $('body').addClass('overflowhidden');
                    gsap.to($('#' + drawID + ' .drawer-block'), { transform: 'translateX(0)', duration: 0.350 });
                })
                $('#' + drawID).focus();
                return false;
            },
            error: function(err) {
                console.warn(err);
            }
        });
        return false;
    });


    // Team image hover
    if ($('.team-box a[href^="mailto:"]').length) {
        $('.team-box a[href^="mailto:"]').addClass('email');
    }

    $(document).on('click', '.team-box figure', function() {
        if ($('.team-box a[href^="mailto:"]').length) {
            if ($(window).width() >= 768) {
                var $this = $(this),
                    $mail = $this.parents('.team-box').find('a.email')[0].href;
                window.location.href = $mail;
            }
        }
    })


    // Team details
    // window.addEventListener('load', (event) => {
    if ($('#trigger-on-load').length) {
        $('#trigger-on-load').trigger('click');
    }
    // });


    // Close Team Drawer
    $(document).on('click', '.drawer-close, .drawer-overlay', function() {
        $('.drawer-main .drawer-overlay').fadeOut(350);
        window.history.replaceState('', '', `/team`);
        // If search model available
        if ($('.model-main').length) {
            // If model open
            if (!$('.model-main').hasClass('open')) {
                $('body').removeClass('overflowhidden');
            }
        }
        gsap.to($('.drawer-main .drawer-block'), {
            transform: 'translateX(100%)',
            duration: 0.350,
            onComplete: function() {
                $('.drawer-main').hide();
            }
        });
        return false;
    })

    // Fetch Search Result
    $("#search-form").on("keyup change submit", (e) => {
        e.preventDefault();
        let search = $("#header_search").val();
        window.dataLayer.push({
            "event": "search",
            "type": "input",
            'input': [search],
        });
        currentRequest = $.ajax({
            url: WP.AJAX_URL,
            method: 'POST',
            data: {
                search,
                action: 'get_peakmedia_search_results',
            },
            beforeSend: function() {
                if (currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function(response) {
                let result = JSON.parse(response);
                if (result.success == 1) {
                    $(".search-results").html(result.html);
                    window.dataLayer.push({
                        "event": "search",
                        "type": "result",
                        'input': [search],
                    });
                }
            },
            error: function(err) {
                console.warn(err);
            }
        });
    })

    // Video hide in Main template

    if ($(".feature-image").length) {
        var figureImg = $(".widget-section-main");
        if ($(figureImg).prev(".feature-image")) {
            $(figureImg).prev(".feature-image").addClass("mobile-show");
        } else {
            $(".feature-image").removeClass("mobile-show");
        }
    }


    // Magazine
    $(document).on('click', '.magazine_trigger', function() {
        var $this = $(this),
            url = $this.data("url");
        $('#magazine').attr('src', url);
        $('html, body').animate({
            scrollTop: $(".magazine-row").offset().top
        }, 1000);
        return false
    })

    if ($('.wpcf7').length) {
        var wpcf7Elm = document.querySelector('.wpcf7');

        wpcf7Elm.addEventListener('wpcf7mailsent', function(event) {
            window.dataLayer.push({
                'event': 'contact',
                "type": "form",
            });
        }, false);
    }


    $("#header .cta-header a").click(() => {
        window.dataLayer.push({
            'event': 'cta',
            "type": "navigation",
        });
    });


    // Magazine page checkbox js
    var limit = 3;
    $('input.privacy-checkbox').on('change', function(evt) {
        if ($('input.privacy-checkbox:checked').length >= limit) {
            this.checked = false;
        }
    });

    var checkbox_text = "";
    $('.magazines-checkbox').click(function() {
        setTimeout(function() {
            checkbox_text = "";
            $('.magazines-checkbox').each(function() {
                if ($(this).is(':checked')) {
                    console.log($(this).parent().find('.wpcf7-list-item-label  span:not(.notinclude)').text())
                    checkbox_text += $(this).parent().find('.wpcf7-list-item-label  span:not(.notinclude)').text();
                    checkbox_text += ", "
                }
            });
            $('#tags').val(checkbox_text);
        }, 300)
    })

    // Video hide in Main template

    if ($(".feature-image").length && $('.widget-section-main').length) {
        var figureImg = $(".widget-section-main");
        if ($(figureImg).prev(".feature-image")) {
            $(figureImg).prev(".feature-image").addClass("mobile-show");
        } else {
            $(".feature-image").removeClass("mobile-show");
        }
    }

    if ($('.greeting-massage').length) {

        // Check height for all of the greetings msgs
        function greetingsHeightCheck() {
            var largest = 0;
            $('.greeting-massage .massage span').each(function() {
                var findHeight = $(this).height();
                if (findHeight > largest) {
                    largest = Math.round(findHeight);
                }
            });
            $(".greeting-text").css({ "min-height": largest + "px" });
        }
        greetingsHeightCheck();
        $(window).on('resize', function() {
            greetingsHeightCheck();
        }).resize();

        // Greeting animation 
        function textAnimation(elem) {
            var height = $(elem).height();
            var index = $(elem).index();
            $('.greeting-massage').css('transform', `translateY(calc(-${height}px * ${index}))`);
            if ($(elem).hasClass('active') != true) {
                $(elem).addClass('active');
                $(elem).siblings().removeClass('active');
            }
            $(window).on('resize', function() {
                height = $(elem).height();
                $('.greeting-massage').css('transform', `translateY(calc(-${height}px * ${index}))`);
            })
        }
        textAnimation()

        // Time 
        var h = 0;
        var m = 0;
        var s = 0;

        function showTime() {

            if (s <= 59) {
                s += 59 / 18;
                if (s >= 59 && m < 59) {
                    s = 0;
                    m += 59 / 6;
                    if (m >= 59 && h <= 24) {
                        m = 0;
                        h++;
                        if (h == 24 && m < 60) {
                            h = 0;
                        }
                    }
                }
            }

            $('.hour').text(h)
            $('.minute').text(Math.round(m))
            $('.secound').text(Math.round(s))


            if (h >= 7 && h < 12) {
                $('.massage').removeClass('noanim')
                $('.greeting-massage').removeClass('noanim')
                textAnimation($("[data-text='guten-morgen']"))
            } else if (h >= 12 && h < 15) {
                textAnimation($("[data-text='mahlzeit']"))
            } else if (h >= 15 && h < 20) {
                textAnimation($("[data-text='schönen-nachmittag']"))
            } else if (h >= 20 && h < 24) {
                textAnimation($("[data-text='guten-abend']"))
                setTimeout(function() {
                    $('.massage').addClass('noanim')
                    $('.greeting-massage').addClass('noanim')
                }, 500)
            } else {
                textAnimation($("[data-text='guten-abend-first']"))
            }
        }
        setInterval(showTime, (2.5 / 1000));
    }

    if ($('#onetrust-banner-sdk').length) {
        function check() {
            if ($('#onetrust-banner-sdk').is(':visible')) {
                $('.stars-ltr-outline').css('bottom', $('#onetrust-banner-sdk').height() + "px");
            }
            $('.onetrust-close-btn-handler , #onetrust-accept-btn-handler').on('click', function() {
                $('.stars-ltr-outline').css('bottom', "0");
                
            })
        }
        check()
    }

    if ($('.stars-ltr').length) {
        $(document).on("scroll", function() {
            var bg_white = $('.greeting-section').offset().top;
            var review_section = $('.review-section').offset().top + $('.review-section').height() - bg_white;
            var pixels = $(document).scrollTop() - bg_white + 300;
            var pageHeight = review_section - $(window).height();
            var to_progress = 100 * pixels / pageHeight;
            var from_progress = 100 - to_progress;
            var window_scrolledd = $(window).scrollTop() + $(window).height() + 5;
            if ($('#onetrust-banner-sdk').is(':visible')) {
                var stars_offset = $(".stars-ltr").offset().top + $(".stars-ltr").outerHeight() + $('#onetrust-banner-sdk').outerHeight();
            } else {
                var stars_offset = $(".stars-ltr").offset().top + $(".stars-ltr").outerHeight();
            }

            if (window_scrolledd >= stars_offset) {
                $(".stars-ltr .stars-ltr-outline").removeClass('fixed').removeClass('complete');
            } else {
                $(".stars-ltr .stars-ltr-outline").addClass('fixed');
                setTimeout(function() {
                    $(".stars-ltr .stars-ltr-outline").addClass('complete');
                }, 50);
            }
            if (from_progress <= 100) {
                $(".stars-ltr").fadeIn(300);
            } else {
                $(".stars-ltr").fadeOut(300);
            }

            $(".stars-ltr .stars-ltr-full").css("clip-path", `inset(0 ${from_progress + '%'} 0 0) `);
        })
    }

    if (location.search.slice(1).split("&")[0].split("=")[1] != undefined && jQuery('body').hasClass('page-id-586')) {
        var team_id = location.search.slice(1).split("&")[0].split("=")[1];
        let stateObj = { id: "100" };
        setTimeout(function() {
            window.history.replaceState(stateObj, "", $('[data-id=' + team_id + ']').data('slug'));
            $('[data-id=' + team_id + ']').trigger('click');
        }, 900)
    }

    if (jQuery('body').hasClass('page-template-template-referenzen') || jQuery('body').hasClass('page-template-template-team') || jQuery('body').hasClass('page-template-template-ratgeber') ) {

        const Loader = $(".loader-cart");

        if ($("#ajax-post-list").length) {


            var paged = 1;
            var loadmore = false;
            var currentRequest = null;
            $(document).ready(function() {
                if (loadmore == true) {
                    if ($("#ajax-post-list").height() < $(window).scrollTop() - 100) {
                        loadmore = false;
                        loadPosts();
                        //  alert("hello");
                    }
                }
            });

            // Referenzen Filter
            $("#ajax-post-list #filter-referenzen").change((e) => {
                e.preventDefault();
                $(".filter-reset .filter-btn").show();
                paged = 1;
                loadPosts();
                //alert("hello1");
            });
            // Ratgeber Filter
            $("#ajax-post-list .filter-categories a.tag, #ajax-post-list .filter-location a.tag").click((e) => {
                $(".filter-reset .filter-btn").show();
                paged = 1;
                setTimeout(() => {
                    loadPosts();
                }, 1000)
            })

            $(".filter-reset a.filter-btn").click((e) => {
                $(e.target).hide();
                $(".filter-number").hide();
                $("#ajax-post-list form").trigger("reset");
                $('#ajax-post-list form input[type="checkbox"]').removeAttr("checked");
                $("#ajax-post-list .filter-categories a.tag").removeClass("active");

                $('.filter-categories, .filter-location').removeClass('active');
                $('.filter-categories > .tag, .filter-location > .tag').removeClass('active');
                paged = 1;
                loadPosts();
                // console.log('load post');
                return false;
            })


            $(".filter-reset a.filter-btn").click((e) => {

                $(e.target).hide();
                $(".filter-number").hide();
                $("#ajax-post-list #filter-referenzen").trigger("reset");
                $('.products input[name="category[]"]:checked').prop('checked', false);
                $('.bruchens input[name="sector[]"]:checked').prop('checked', false);
                $("#ajax-post-list .filter-categories a.tag").removeClass("active");
                $('.filter-categories, .filter-location').removeClass('active');
                $('.filter-categories > .tag, .filter-location > .tag').removeClass('active');

                paged = 1;
                loadPosts();
                // alert("hello3");


                return false;
            })


            function loadPosts() {
                var cat_num = $('.products input[name="category[]"]:checked').filter(":checked").length;
                if (cat_num > 0) {
                    $(".cat_num .filter-number").show();

                }
                var sec_num = $('.products input[name="sector[]"]:checked').filter(":checked").length;
                if (sec_num > 0) {
                    $(".sec_num .filter-number").show();

                }
                Loader.show();
                let posttype = $("#ajax-post-list").data("post");
                var category = [];
                var sector = [];
                var location = [];
                $('.products input[name="category[]"]:checked').each(function() {
                    category.push(this.value);

                });
                $('.bruchens input[name="sector[]"]:checked').each(function() {
                    sector.push(this.value);
                });

                let formdata

                if (posttype == 'referenzen') {
                    //   $('.filter-result-row').append('<div id="loaderajax"><div class="loader-ajax"><div class="loader-wrap"><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div></div><div class="loader-text">Please wait</div></div></div>');
                    currentRequest = $.ajax({
                        url: WP.AJAX_URL,
                        method: 'POST',
                        data: {
                            paged: paged,
                            category: category,
                            sector: sector,
                            action: 'peakmedia_' + posttype,
                        },
                        beforeSend: function() {
                            if (currentRequest != null) {
                                currentRequest.abort();
                            }
                        },
                        success: function(response) {

                            let result = JSON.parse(response);
                            // alert("hello4");
                            if (paged == 1) {
                                $(".filter-result-row .cols3").html(result.html);
                            } else {
                                $(".filter-result-row .cols3").append(result.html);
                            }
                            loadmore = result.hasmore;
                            //paged++;
                            Loader.hide();
                            if($('.filter-result-row .cols .col').length == 0){
                                $('.filter-result-row .cols').append('<p class="error-msg">Keine Ergebnisse für diese Auswahl gefunden.</p>')
                            }else{
                                if($('.error-msg').length){
                                    $('.error-msg').remove()
                                }
                            }
                            
                        },
                        complete: function() {
                            setTimeout(() => {

                                $('#loaderajax').fadeOut(450, function() {
                                    $(this).remove();
                                });
                            }, "1000")
                        },
                        error: function(err) {

                        }
                    });
                } else {

                    formdata = { category: $("#ajax-post-list .filter-categories a.tag.active").map((i, e) => $(e).data("id")).get() };

                   var formdata1 = { location: $("#ajax-post-list .filter-location a.tag.active").map((i, e) => $(e).data("id")).get() };
                    

                    currentRequest = $.ajax({
                        url: WP.AJAX_URL,
                        method: 'POST',
                        data: {
                            paged,
                            formdata,
                            formdata1,
                            action: 'peakmedia_' + posttype,
                        },
                        beforeSend: function() {
                            if (currentRequest != null) {
                                currentRequest.abort();
                            }
                        },
                        success: function(response) {
                            let result = JSON.parse(response);
                            // alert("hello4");
                            if (paged == 1) {
                                $(".filter-result-row .cols3").html(result.html);
                            } else {
                                $(".filter-result-row .cols3").append(result.html);
                            }
                            loadmore = result.hasmore;
                            if(posttype!='team'){
                                paged++;
                            }

                            if($('.filter-result-row .cols .col').length == 0){
                                $('.filter-result-row .cols').append('<p class="error-msg">Keine Ergebnisse für diese Auswahl gefunden.</p>')
                            }else{
                                if($('.error-msg').length){
                                    $('.error-msg').remove()
                                }
                            }
                            
                            Loader.hide();
                        },
                        error: function(err) {
                            console.warn(err);
                        }
                    });
                }

            }


            setTimeout(function() {

                $(".filter-reset .filter-btn").show();
                var cat_num = $('.products input[name="category[]"]:checked').filter(":checked").length;
                if (cat_num > 0) {
                    $(".cat_num .filter-number").show();
                    if ($(".cat_num .filter-number").show()) {
                        $(".filter-head .container .filter-row").addClass("active");
                    }
                    $(".cat_num .filter-number").html(cat_num);

                }
                var sec_num = $('.bruchens input[name="sector[]"]:checked').filter(":checked").length;
                if (sec_num > 0) {
                    $(".sec_num .filter-number").show();
                    if ($(".sec_num .filter-number").show()) {
                        $(".filter-head .container .filter-row").addClass("active");
                    }
                    $(".sec_num .filter-number").html(sec_num);

                }
                window.cat1 = cat_num;
                window.cat2 = sec_num;
                loadPosts();
                //}
            }, 100);

        }

    }


// // Gallery post ajax filter start
  
//     if ($("#ajax-post-list-gallery").length) {
         
//         var paged = 1;
//         var loadmore = false;
//         var currentRequest = null;
//         $(window).scroll(function() {
//             if (loadmore == true) {
//                 if ($("#ajax-post-list-gallery").height() < $(window).scrollTop() - 100) {
//                     loadmore = false;
//                     getgallerypost();
//                 }
//             }
//         });

//         // Referenzen Filter
//         $("#ajax-post-list-gallery form").change((e) => {
//             e.preventDefault();
//             $(".filter-reset .filter-btn").show();
//             paged = 1;
//             getgallerypost();
//         });

//         // Ratgeber Filter
//         $("#ajax-post-list-gallery .filter-categories a.tag, #ajax-post-list-gallery .filter-location a.tag").click((e) => {
//             $(".filter-reset .filter-btn").show();
//             paged = 1;
//             setTimeout(() => {
//                 getgallerypost();
//             }, 1000)
//         })

//         $(".filter-reset a.filter-btn").click((e) => {
//             $(e.target).hide();
//             $(".filter-number").hide();
//             $("#ajax-post-list-gallery form").trigger("reset");
//             $('#ajax-post-list-gallery form input[type="checkbox"]').removeAttr("checked");
//             $("#ajax-post-list-gallery .filter-categories a.tag").removeClass("active");

//             $('.filter-categories, .filter-location').removeClass('active');
//             $('.filter-categories > .tag, .filter-location > .tag').removeClass('active');
//             paged = 1;
//             getgallerypost();
//             return false;
//         })


//         function getgallerypost(loader = true) {
//             if (loader == true) {
//                 Loader.show();
//             }

//             var cat_num = $('.products input[name="categorygallery[]"]:checked').filter(":checked").length;
//             if (cat_num > 0) {
//                 $(".cat_num .filter-number").show();

//             }
//             var sec_num = $('.products input[name="sectorgallery[]"]:checked').filter(":checked").length;
//             if (sec_num > 0) {
//                 $(".sec_num .filter-number").show();

//             }
//             Loader.show();
//             let posttype = $("#ajax-post-list-gallery").data("post");
//             var category = [];
//             var sector = [];
//             $('.products input[name="categorygallery[]"]:checked').each(function() {
//                 category.push(this.value);

//             });
//             $('.bruchens input[name="sectorgallery[]"]:checked').each(function() {
//                 sector.push(this.value);
//             });

//             let formdata
//             if (posttype == 'gallery') {
//                 //  $('.filter-result-row').append('<div id="loaderajax"><div class="loader-ajax"><div class="loader-wrap"><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div></div><div class="loader-text">Please wait</div></div></div>');
//                 currentRequest = $.ajax({
//                     url: WP.AJAX_URL,
//                     method: 'POST',
//                     data: {
//                         paged: paged,
//                         category: category,
//                         sector: sector,
//                         action: 'peakmedia_' + posttype,
//                     },
//                     beforeSend: function() {
//                         if (currentRequest != null) {
//                             currentRequest.abort();
//                         }
//                     },
//                     success: function(response) {



//                         let result = JSON.parse(response);
//                         // alert("hello4");
//                         if (paged == 1) {
//                             $("#galleryajaxresult").html(result.html);
//                         } else {
//                             $("#galleryajaxresult").append(result.html);
//                         }
//                         loadmore = result.hasmore;
//                         paged++;
//                         Loader.hide();
//                     },
//                     complete: function() {
//                         setTimeout(() => {

//                             $('#loaderajax').fadeOut(450, function() {
//                                 $(this).remove();
//                             });
//                         }, "1000")
//                         fancyBox();
//                     },
//                     error: function(err) {
//                         console.warn(err);
//                     }
//                 });
//             } else {
//                 formdata = { category: $("#ajax-post-list-gallery .filter-categories a.tag.active").map((i, e) => $(e).data("id")).get() };
//                 currentRequest = $.ajax({
//                     url: WP.AJAX_URL,
//                     method: 'POST',
//                     data: {
//                         paged,
//                         formdata,
//                         action: 'peakmedia_' + posttype,
//                     },
//                     beforeSend: function() {
//                         if (currentRequest != null) {
//                             currentRequest.abort();
//                         }
//                     },
//                     success: function(response) {
//                         let result = JSON.parse(response);
//                         // alert("hello4");
//                         if (paged == 1) {
//                             $("#galleryajaxresult").html(result.html);
//                         } else {
//                             $("#galleryajaxresult").append(result.html);
//                         }
//                         loadmore = result.hasmore;
//                         paged++;
//                         Loader.hide();
//                         fancyBox();
//                     },
//                     error: function(err) {
//                         console.warn(err);
//                     }
//                 });
//             }

//         }

//         setTimeout(function() {
//             if (window.cat2 == 0 && window.cat1 == 0)
//                 getgallerypost(false);
//         }, 1000);

//     }


//     if ($("#ajax-post-list-gallery").length) {

//         const Loader = $(".loader-cart");

//         if ($("#ajax-post-list-gallery").length) {

//                 var paged = 1;
//                 var loadmore = false;
//                 var currentRequest = null;
//                 $(document).ready(function() {
//                     if (loadmore == true) {
//                         if ($("#ajax-post-list-gallery").height() < $(window).scrollTop() - 100) {
//                             loadmore = false;
//                             getgallerypost();
//                             //  alert("hello");
//                         }
//                     }
//                 });

//                 // Referenzen Filter
//                 $("#ajax-post-list-gallery #filter-gallery").change((e) => {
//                     e.preventDefault();
//                     $(".filter-reset .filter-btn").show();
//                     paged = 1;
//                     getgallerypost();
//                     //alert("hello1");
//                 });
//                 // Ratgeber Filter
//                 $("#ajax-post-list-gallery .filter-categories a.tag, #ajax-post-list-gallery .filter-location a.tag").click((e) => {
//                     $(".filter-reset .filter-btn").show();
//                     paged = 1;
//                     setTimeout(() => {
//                         getgallerypost();
//                     }, 1000)
//                 })

//                 $(".filter-reset a.filter-btn").click((e) => {
//                     $(e.target).hide();
//                     $(".filter-number").hide();
//                     $("#ajax-post-list-gallery form").trigger("reset");
//                     $('#ajax-post-list-gallery form input[type="checkbox"]').removeAttr("checked");
//                     $("#ajax-post-list-gallery .filter-categories a.tag").removeClass("active");

//                     $('.filter-categories, .filter-location').removeClass('active');
//                     $('.filter-categories > .tag, .filter-location > .tag').removeClass('active');
//                     paged = 1;
//                     getgallerypost();
//                     // console.log('load post');
//                     return false;
//                 })


//                 $(".filter-reset a.filter-btn").click((e) => {

//                     $(e.target).hide();
//                     $(".filter-number").hide();
//                     $("#ajax-post-list-gallery #filter-gallery").trigger("reset");
//                     $('.products input[name="categorygallery[]"]:checked').prop('checked', false);
//                     $('.bruchens input[name="sectorgallery[]"]:checked').prop('checked', false);
//                     $("#ajax-post-list-gallery .filter-categories a.tag").removeClass("active");
//                     $('.filter-categories, .filter-location').removeClass('active');
//                     $('.filter-categories > .tag, .filter-location > .tag').removeClass('active');

//                     paged = 1;
//                     getgallerypost();
//                     // alert("hello3");


//                     return false;
//                 })


//                 $('.gallery_filter input[type="checkbox"]').click((e) => {
//                     var total_checked = 0;
//                     jQuery('input[type="checkbox"]').each(function(){
//                         if(jQuery(this).is(':checked')){
//                             total_checked = 1;
//                             console.log(jQuery(this).attr('class'))
//                         }
//                     });
                    

//                     if(total_checked == 0){
//                         jQuery('.gallery_filter .gallery-grid-item').show();
//                     }else{
//                         jQuery('.gallery_filter .gallery-grid-item').hide();
//                         jQuery('input[type="checkbox"]').each(function(){
//                             hideclass = "";
//                             if(jQuery(this).is(':checked')){
                                
//                                 var hideclass = jQuery(this).attr('class');
//                                 console.log(hideclass);
//                                 jQuery('.gallery_filter .gallery-grid-item').each(function(){

//                                     if(jQuery(this).hasClass(hideclass)){
//                                         console.log(hideclass);
//                                         jQuery(this).show();
//                                     }
//                                 })
//                             }
//                         });
//                     }

//                 })


//             function getgallerypost(){

//                 var cat_num = $('.products input[name="categorygallery[]"]:checked').filter(":checked").length;
//                 if (cat_num > 0) {
//                     $(".cat_num .filter-number").show();

//                 }
//                 var sec_num = $('.products input[name="sectorgallery[]"]:checked').filter(":checked").length;
//                 if (sec_num > 0) {
//                     $(".sec_num .filter-number").show();

//                 }
//                 Loader.show();
//                 let posttype = $("#ajax-post-list-gallery").data("post");
//                 var category = [];
//                 var sector = [];
//                 $('.products input[name="categorygallery[]"]:checked').each(function() {
//                     category.push(this.value);

//                 });


//                 $('.bruchens input[name="sectorgallery[]"]:checked').each(function() {
//                     sector.push(this.value);
//                 });

//                 let formdata

//                 if (posttype == 'gallery') {
  
//                     currentRequest = $.ajax({
//                         url: WP.AJAX_URL,
//                         method: 'POST',
//                         data: {
//                             paged: paged,
//                             category: category,
//                             sector: sector,
//                             action: 'peakmedia_' + posttype,
//                         },
//                         beforeSend: function() {
//                             if (currentRequest != null) {
//                                 currentRequest.abort();
//                             }
//                         },
//                         success: function(response) {

//                             let result = JSON.parse(response);
//                            // alert("hello4");
//                             if (paged == 1) {
//                                 $("#galleryajaxresult").html(result.html);
//                             } else {
//                                 $("#galleryajaxresult").append(result.html);
//                             }
//                             loadmore = result.hasmore;
//                             //paged++;
//                             Loader.hide();
//                         },
//                         complete: function() {
//                             setTimeout(() => {

//                                 $('#loaderajax').fadeOut(450, function() {
//                                     $(this).remove();
//                                 });
//                             }, "1000")
//                             fancyBox();
//                         },
//                         error: function(err) {

//                         }
//                     });
//                 } else {

//                     formdata = { category: $("#ajax-post-list-gallery .filter-categories a.tag.active").map((i, e) => $(e).data("id")).get() };
//                     currentRequest = $.ajax({
//                         url: WP.AJAX_URL,
//                         method: 'POST',
//                         data: {
//                             paged,
//                             formdata,
//                             action: 'peakmedia_' + posttype,
//                         },
//                         beforeSend: function() {
//                             if (currentRequest != null) {
//                                 currentRequest.abort();
//                             }
//                         },
//                         success: function(response) {
//                             let result = JSON.parse(response);
//                             //console.log(result)
//                             alert("hello 5");
//                             if (paged == 1) {
//                                 $("#galleryajaxresult").html(result.html);
//                             } else {
//                                 $("#galleryajaxresult").append(result.html);
//                             }
//                             loadmore = result.hasmore;
//                             paged++;
//                             Loader.hide();
//                             fancyBox();
//                         },
//                         error: function(err) {
//                             console.warn(err);
//                         }
//                     });
//                 }
//             }   // function getgallerypost over

//                     setTimeout(function() {
//                         $(".filter-reset .filter-btn").show();
//                         var cat_num = $('.products input[name="categorygallery[]"]:checked').filter(":checked").length;
//                         if (cat_num > 0) {
//                             $(".cat_num .filter-number").show();
//                             if ($(".cat_num .filter-number").show()) {
//                                 $(".filter-head .container .filter-row").addClass("active");
//                             }
//                             $(".cat_num .filter-number").html(cat_num);

//                         }
//                         var sec_num = $('.bruchens input[name="sectorgallery[]"]:checked').filter(":checked").length;
//                         if (sec_num > 0) {
//                             $(".sec_num .filter-number").show();
//                             if ($(".sec_num .filter-number").show()) {
//                                 $(".filter-head .container .filter-row").addClass("active");
//                             }
//                             $(".sec_num .filter-number").html(sec_num);

//                         }
//                        }
//                         window.cat1 = cat_num;
//                         window.cat2 = sec_num;
//                         getgallerypost();
//                         //}
//                     }, 100);

//         }  // $("#ajax-post-list-gallery").length over

//     }  // hasClass function over

// // Gallery post ajax filter over
                                
                                //activeItemDiv();
                                //console.log(activeItems[3]);
                                //console.log(activeItems);
                                
                                
    // $('.gallery_filter input[type="checkbox"]').click((e) => {
    //     console.log('loadd');
    //     var total_checked = 0;
    //     jQuery('input[type="checkbox"]').each(function(){
    //         if(jQuery(this).is(':checked')){
    //             total_checked = 1;
    //             //console.log(jQuery(this).attr('class'))
    //             console.log('check once', $(this));
    //         }
    //     });
    //     if(total_checked == 0){
    //         console.log('uncheck');
    //         jQuery('.gallery_filter .gallery-grid-item').show();
    //         activeItemDiv();
    //     }else{
    //         console.log('check one');
    //         jQuery('.gallery_filter .gallery-grid-item').hide();
    //         jQuery('input[type="checkbox"]').each(function(){
    //             hideclass = "";
    //             if(jQuery(this).is(':checked')){                                
    //                 var hideclass = jQuery(this).attr('class');
    //                 //console.log(hideclass);
    //                 jQuery('.gallery_filter .gallery-grid-item').each(function(){
    
    //                     if(jQuery(this).hasClass(hideclass)){
    //                         //console.log(hideclass);
    //                         jQuery(this).show();
    //                     }
    //                 })
    //                 activeItemDiv();
    //             }
    //         });
    //     }
    
    // })

    // filter tag hover 
    let hoverTimeoute
    $(".filter-categories .tag ,.filter-box .tag").on("mouseenter",function() {
        $(this).parent().addClass("hovering")
        clearTimeout(hoverTimeoute)
    }).on("mouseleave",function () {
        hoverTimeoute = setTimeout(() => {
            $(this).parent().removeClass("hovering")
        }, 100);
    })


});  
$(document).ready( function(){
    $('.gallery_filter input[type="checkbox"]').click((e) => {
            var total_checked = 0;
            
            jQuery('.gallery_filter input[type="checkbox"]').each(function(){
                //if(jQuery(this).is(':checked')){
                if(jQuery(this).is(':checked')){
                    total_checked = 1;
                    // console.log("total_checked :", total_checked)
                }
            });

            
            // console.log("total_222 :", total_checked)

            if(total_checked == 0){
                jQuery('.gallery_filter .gallery-grid-item').show();
                activeItemDiv();
            }else{
                jQuery('.gallery_filter .gallery-grid-item').hide();
                jQuery('input[type="checkbox"]').each(function(){
                    hideclass = "";
                    if(jQuery(this).is(':checked')){
                        
                        var hideclass = jQuery(this).attr('class');
                        //console.log(hideclass);
                        jQuery('.gallery_filter .gallery-grid-item').each(function(){

                            if(jQuery(this).hasClass(hideclass)){
                                //console.log(hideclass);
                                jQuery(this).show();
                            }
                        })
                        activeItemDiv();
                    }
                });
            }
                
        
        })

        jQuery('#galleryreset').click(function () {
            jQuery('.gallery_filter .gallery-grid-item').show();
            activeItemDiv();
        })

        if($(".filter-section .filter-box .tag.active").length){
            $(".filter-section .filter-head .filter-row").addClass("active")
        }
        $(".filter-section .filter-box .tag").on("click",function() {
            let $this = $(this)
            $(this).addClass("active")
            $(".filter-section .filter-box .tag").not($this).removeClass("active")
            $(".filter-section .filter-head .filter-row").addClass("active")
            $this.parent().addClass("selected")
            return false;
        })
        $(".filter-section .filter-reset .filter-btn").on("click",function() {
            $(".filter-section .filter-box .tag").removeClass("active")
            $(".filter-categories.selected , .button-set.selected").removeClass("selected")
        })

        
        let resizeInterval;
        function updScrollClass(el) {
            if(!el){
                return
            }
          return el.classList.toggle("scrollbarOn", el.scrollWidth > el.clientWidth);
        }
        $(window).on("resize", function () {
          clearTimeout(resizeInterval);
          resizeInterval = setTimeout(() => {
            updScrollClass($(".overflow-scroll")[0]);
          }, 200);
        }).resize();
})
function activeItemDiv() {
    jQuery('.gallery_filter .gallery-grid-item').removeClass("gallery-grid-item--width2, gallery-grid-item-half");                    
    var activeItems = [];
    $(".gallery-grid-item").each(function(){
        
        if($(this).is(":visible")){
            $(this).removeClass("gallery-grid-item--width2"); 
           // console.log('galleryVisible', $(this));
            activeItems.push($(this));
        }
    });
    if(activeItems.length){
        for(let i = 3; i < activeItems.length;  ) {
            activeItems[i].addClass("gallery-grid-item--width2");
            i += 8
        }
        for(let i = 6; i < activeItems.length;) {
            activeItems[i].addClass("gallery-grid-item-half");
            i += 8
        }
        for(let i = 7; i < activeItems.length;) {
            activeItems[i].addClass("gallery-grid-item-half");
            i += 8 
        }
    }

}
activeItemDiv();

if(document.querySelector('.cookie-settings') != null){
    document.querySelector('.cookie-settings').setAttribute('id','csconsentlink');
    document.querySelector('.cookie-settings').addEventListener('click', function(){
     CookieScript.instance.show();
    })
}


